const signInES = {
	title: "Entrar",
	subtitle: "Gestiona tus reservas, tu calendario y tu equipo.",
	email: "Correo electrónico",
	password: "Contraseña",
	rememberMe: "Recordarme",
	button: "Entrar",
	loading: "Iniciando...",
	forgotPassword: "¿Olvidaste tu contraseña?",
	noAccount: "¿No tienes una cuenta?",
	createCustomer: "Crear una cuenta de cliente",
	createCustomerDesc: "Reserva citas y evita la fila",
	registerBusiness: "Registrar tu negocio",
	registerBusinessDesc: "Recibe reservas en línea, gratis por 14 días",
	secureNote: "Tus datos viajan cifrados",
	sessionExpired: "Tu sesión ha expirado. Vuelve a iniciar sesión.",
};
export default signInES;
